export const formatDate = (iso: string) =>
  new Date(iso).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

// Máscara progressiva dd/mm/aaaa (mesmo padrão de maskCep/maskCnpj/maskCpf) —
// usada em campos de data que evitam o <input type="date"> nativo (o popup
// de calendário dele é UI do próprio navegador, fora do DOM, impossível de
// estilizar; ver components/Modals/*PacienteDrawer).
export const maskDate = (value: string): string => {
  const digits = value.replace(/\D/g, "").slice(0, 8);
  return digits
    .replace(/^(\d{2})(\d)/, "$1/$2")
    .replace(/^(\d{2})\/(\d{2})(\d)/, "$1/$2/$3");
};

// "dd/mm/aaaa" completo -> "aaaa-mm-dd" (formato que o backend espera em
// campos LocalDate). Retorna "" se a data estiver incompleta ou não for uma
// data real (ex: 31/02, que o Date nativo "corrigiria" silenciosamente pra
// 03/03 — a comparação de dia/mês abaixo rejeita esse caso).
export const brDateToIso = (value: string): string => {
  const digits = value.replace(/\D/g, "");
  if (digits.length !== 8) return "";
  const dia = digits.slice(0, 2);
  const mes = digits.slice(2, 4);
  const ano = digits.slice(4, 8);
  const iso = `${ano}-${mes}-${dia}`;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime()) || d.getUTCDate() !== Number(dia) || d.getUTCMonth() + 1 !== Number(mes)) return "";
  return iso;
};

// "aaaa-mm-dd" (ISO, vindo do backend) -> "dd/mm/aaaa" pra exibir no campo.
export const isoDateToBr = (value?: string): string => {
  if (!value) return "";
  const [ano, mes, dia] = value.split("-");
  if (!ano || !mes || !dia) return "";
  return `${dia}/${mes}/${ano}`;
};
